module.exports = __webpack_public_path__ + "static/media/my_assets_search_server.5c59f5b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/my_assets_search_server.png
// module id = 750
// module chunks = 0 1